import { Textarea } from "../../tremor/Textarea";
import { Button } from "../../tremor/Button";
import { Text } from "../../tremor/Text";
import { Card } from "../../tremor/Card";
import { Icon } from "../../tremor/Icon";
import { useEffect, useMemo, useRef, useState } from "react";
import React from "react";
import { useBackend } from "../../layouts/Wrapper";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ErrorBoundary } from "react-error-boundary";
import { ArrowDownTrayIcon, DocumentChartBarIcon, PencilIcon, PhotoIcon, } from "@heroicons/react/24/outline";
import ChartBase from "../Chart/ChartBase";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuIconWrapper, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger, } from "../../tremor/DropdownMenu";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "../../tremor/Accordion";
import { useTheme } from "../../layouts/Dashboard/useTheme";
import { toast } from "sonner";
dayjs.extend(relativeTime);
export const QuestionMessage = ({ isLast, message, onAdd, onEdit, onReply }) => {
    const { adminMode, containerRef, backend } = useBackend();
    const { dashboard } = useDashboard();
    const theme = useTheme();
    const elementRef = useRef(null);
    const [output, setOutput] = useState();
    const [code, setCode] = useState("");
    const [answer, setAnswer] = useState("");
    const [editing, setEditing] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const [options, setOptions] = useState([]);
    const title = useMemo(() => {
        var _a, _b, _c;
        if ((_c = (_b = (_a = output === null || output === void 0 ? void 0 : output.options) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.text) {
            return output.options.plugins.title.text;
        }
        return "Chart";
    }, [output]);
    const { role, content } = message;
    const onDownload = (format) => {
        if (!backend)
            return;
        toast.promise(() => {
            return backend.question(message.question).exportMessage(message.id, format, theme);
        }, {
            loading: `Exporting widget as ${format}...`,
            success: (blob) => {
                let blobUrl = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.download = "Download." + format;
                a.href = blobUrl;
                document.body.appendChild(a);
                a.click();
                a.remove();
                return "Widget exported";
            },
            error: (error) => "Error exporting widget: " + error.message,
        });
    };
    useEffect(() => {
        var _a;
        if (role === "assistant" || role === "tool") {
            let textContent = "";
            if (content) {
                textContent =
                    typeof content === "string"
                        ? content
                        : content.map((a) => (a.type === "text" ? a.text : "")).join("\n");
            }
            if ((textContent || "").search("```") >= 0) {
                if (textContent.split("```python")[1]) {
                    let code = textContent.split("```python")[1].split("```")[0].trim();
                    setCode(code);
                }
                if (textContent.split("```json")[1]) {
                    let out = textContent.split("```json")[1].split("```")[0].trim();
                    setOutput(JSON.parse(out));
                    let ans = textContent.split("```json")[1].split("```")[1];
                    setAnswer(ans || "");
                }
                setOptions([]);
            }
            else if ((textContent || "").search("`") >= 0) {
                let opts = (_a = textContent
                    .match(/(\`.*?\`)/g)) === null || _a === void 0 ? void 0 : _a.map((a) => a.replace(/`/g, ""));
                let ans = textContent.split("`")[0];
                setAnswer(ans);
                setOptions(opts || []);
            }
            else {
                setAnswer(textContent);
                setOptions([]);
            }
        }
        else {
            setAnswer(content);
        }
    }, [content, role]);
    if (role === "user") {
        let text = content;
        let code = "";
        if (text.search("```") >= 0) {
            text =
                text.split("```json")[0] + text.split("```json")[1].split("```")[1];
            code = content.split("```json")[1].split("```")[0].trim();
        }
        return (React.createElement("div", { className: "onvo-w-full onvo-flex onvo-flex-col onvo-group" },
            React.createElement("div", { className: "onvo-question-message-user onvo-rounded-2xl onvo-py-3 onvo-px-4 onvo-bg-black/5 dark:onvo-bg-white/10 onvo-relative onvo-mb-3 onvo-flex onvo-flex-row onvo-items-start onvo-justify-start onvo-gap-3 onvo-self-end " + (editing ? "onvo-w-full" : "onvo-max-w-[80%]") },
                React.createElement("div", { className: "onvo-w-full onvo-max-w-none" },
                    editing ? (React.createElement(Textarea, { className: "!onvo-text-[0.875rem] !onvo-outline-none focus:onvo-outline-none focus:onvo-border-transparent focus:onvo-ring-0 !onvo-p-0 !onvo-leading-[1.5142857rem] !onvo-bg-transparent !onvo-shadow-none onvo-border-none", defaultValue: content, onChange: (e) => setNewMessage(e.target.value) })) : (React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, text) },
                        React.createElement(ReactMarkdown, { className: "onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert ", remarkPlugins: [remarkGfm] }, text),
                        code.trim() !== "" && adminMode && (React.createElement(Accordion, { type: "single", className: "onvo-leading-none onvo-mb-2 onvo-mt-2", collapsible: true },
                            React.createElement(AccordionItem, { value: "item-1", className: "onvo-border-b-0" },
                                React.createElement(AccordionTrigger, { className: "onvo-border-b-0 !onvo-py-2 !onvo-px-2 onvo-rounded-md onvo-background-color" },
                                    React.createElement("span", null, "Show advanced widget builder output")),
                                React.createElement(AccordionContent, { className: "onvo-pt-2" },
                                    React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, code) },
                                        React.createElement("article", { className: "onvo-question-assistant-code-wrapper onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert onvo-inline onvo-w-full" },
                                            React.createElement(ReactMarkdown, { className: "onvo-question-assistant-code -onvo-mt-5" }, "```json\n" + code + "\n```"))))))))),
                    editing ? (React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-justify-end onvo-items-center onvo-gap-2 onvo-mt-2" },
                        React.createElement(Button, { className: "!onvo-rounded-full", variant: "secondary", color: "gray", onClick: () => {
                                setEditing(false);
                            } }, "Cancel"),
                        React.createElement(Button, { className: " !onvo-rounded-full", onClick: () => {
                                onEdit(newMessage);
                                setEditing(false);
                            } }, "Save"))) : (React.createElement(Icon, { onClick: () => {
                            setEditing(true);
                            setNewMessage(content);
                        }, className: "onvo-absolute onvo-cursor-pointer onvo-top-2 -onvo-left-8 onvo-hidden group-hover:onvo-block", icon: PencilIcon, variant: "shadow", size: "xs" }))))));
    }
    const ImageDownloadEnabled = useMemo(() => {
        var _a;
        if (output && output.type === "table")
            return false;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.disable_download_images)
            return false;
        return true;
    }, [dashboard, adminMode, output]);
    const ReportDownloadEnabled = useMemo(() => {
        var _a;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.disable_download_reports)
            return false;
        return true;
    }, [dashboard, adminMode]);
    const AddToDashboardEnabled = useMemo(() => {
        var _a;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets)
            return true;
        return false;
    }, [dashboard, adminMode]);
    if (role === "assistant" && (!answer || answer.trim() === ""))
        return null;
    return (React.createElement("div", { ref: elementRef, className: "onvo-question-message-assistant onvo-relative onvo-mb-3 onvo-flex onvo-flex-row onvo-items-start onvo-justify-start onvo-gap-3" },
        React.createElement("div", { className: "onvo-w-full" },
            adminMode && code.trim() !== "" && (React.createElement(Accordion, { type: "single", className: "onvo-leading-none onvo-mb-2", collapsible: true },
                React.createElement(AccordionItem, { value: "item-1", className: "onvo-border-b-0" },
                    React.createElement(AccordionTrigger, { className: "onvo-border-b-0 !onvo-py-2 !onvo-px-3 onvo-rounded-2xl onvo-bg-slate-100 dark:onvo-bg-slate-700" },
                        React.createElement("span", null, "Show working")),
                    React.createElement(AccordionContent, { className: "onvo-pt-2" },
                        React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, code) },
                            React.createElement("article", { className: "onvo-question-assistant-code-wrapper onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert onvo-inline onvo-w-full" },
                                React.createElement(ReactMarkdown, { className: "onvo-question-assistant-code !onvo-rounded-2xl -onvo-mt-5" }, "```python\n" + code + "\n```"))))))),
            output && (React.createElement(Card, { className: "onvo-group onvo-question-assistant-chart onvo-foreground-color onvo-relative onvo-mb-2 onvo-px-0 onvo-py-0 onvo-flex onvo-flex-col" },
                React.createElement("div", { className: "onvo-py-3 onvo-px-2 " +
                        (output.type === "metric" ? "onvo-h-32" : "onvo-h-96") },
                    React.createElement(ChartBase, { json: output, title: title })),
                React.createElement("div", { className: "onvo-chart-card-dropdown-wrapper onvo-py-2 onvo-px-2 onvo-z-20 onvo-border-solid onvo-border-t onvo-border-black/5 dark:onvo-border-white/10 onvo-rounded-b-2xl onvo-background-color onvo-flex onvo-w-full onvo-justify-between onvo-flex-row onvo-items-center", onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, onMouseDown: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, onMouseUp: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    } },
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" }, adminMode && (React.createElement(Button, { variant: "secondary", onClick: () => onAdd(true) }, "Add to library"))),
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" },
                        AddToDashboardEnabled && (React.createElement(Button, { variant: "primary", onClick: () => onAdd() }, "Add to dashboard")),
                        (ImageDownloadEnabled || ReportDownloadEnabled) && (React.createElement(DropdownMenu, { modal: false },
                            React.createElement(DropdownMenuTrigger, { asChild: true },
                                React.createElement(Icon, { variant: "shadow", className: "onvo-foreground-color onvo-border-black/10 dark:onvo-border-white/10", icon: ArrowDownTrayIcon })),
                            React.createElement(DropdownMenuContent, { container: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current, className: "onvo-min-w-56 onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" },
                                ReportDownloadEnabled && (React.createElement(React.Fragment, null,
                                    React.createElement(DropdownMenuLabel, null, "Reports"),
                                    React.createElement(DropdownMenuGroup, null,
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("xlsx") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DocumentChartBarIcon, { className: "onvo-size-4" }),
                                                React.createElement("span", null, "Download as excel"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("csv") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(DocumentChartBarIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as CSV")))))),
                                ImageDownloadEnabled && ReportDownloadEnabled && (React.createElement(DropdownMenuSeparator, { className: "onvo-border-black/10 dark:onvo-border-white/10" })),
                                ImageDownloadEnabled && (React.createElement(React.Fragment, null,
                                    React.createElement(DropdownMenuLabel, null, "Images"),
                                    React.createElement(DropdownMenuGroup, null,
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("svg") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(PhotoIcon, { className: "onvo-size-4" }),
                                                React.createElement("span", null, "Download as SVG"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("png") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(PhotoIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as PNG"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("jpeg") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(PhotoIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as JPEG"))))))))))))),
            React.createElement("article", { className: "onvo-question-assistant-code-wrapper onvo-max-w-none onvo-prose onvo-prose-sm dark:onvo-prose-invert onvo-w-full" },
                answer && answer.trim() !== "" && (React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, answer) },
                    React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm] }, answer))),
                options && options.length > 0 && isLast && (React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-gap-2 -onvo-mt-2" }, options.map((a) => (React.createElement(Button, { className: "!onvo-rounded-full", onClick: () => onReply(a), key: a, color: "gray", variant: "secondary" }, a)))))))));
};
//# sourceMappingURL=QuestionMessage.js.map